import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import TagManager from 'react-gtm-module'
import { removeSearch, combineHashSearchQueryString, stringifyQueryStringObject } from "./services/parseQueryString";
import environmentSettings from './constants/environmentSettings';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const helmetContext = {};

const resumptionRedirect = () => {
    if (window.location.pathname === "/continueapplication.ashx") {
        window.location = "/apply" + window.location.search;
    }
}

const hashRedirect = () => {
    if (!!window.location.hash) {
        const hashWithoutHash = window.location.hash.substring(1);
        const hashWithoutSearch = removeSearch(hashWithoutHash);
        const combinedQueryString = combineHashSearchQueryString(window.location);
        window.location = hashWithoutSearch + stringifyQueryStringObject(combinedQueryString);
    }
}

const tagManagerArgs = {
    gtmId: environmentSettings.gtmId,
    auth: environmentSettings.gtmAuth,
    preview: environmentSettings.gtmPreview
}

TagManager.initialize(tagManagerArgs);

resumptionRedirect();
hashRedirect();

const root = ReactDOM.createRoot(
  document.getElementById('root') //as HTMLElement
);
root.render(
  <HelmetProvider context={helmetContext}>
    <React.StrictMode>
      <App id="app">
        <Helmet></Helmet>
      </App>
    </React.StrictMode>
  </HelmetProvider>
);